import { initOAuth2Authorize } from './oauth2/authorize.js';

initOAuth2Authorize();
